import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { isValid } from "date-fns"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Safely parses a date value (Date object, ISO string, MM/DD/YYYY, etc.)
 * Returns defaultDate if the input is invalid or missing.
 */
export function safeParseDate(dateInput, defaultDate = new Date()) {
  if (!dateInput) return defaultDate;
  if (dateInput instanceof Date) return isValid(dateInput) ? dateInput : defaultDate;
  if (typeof dateInput === 'string') {
    // Try native Date parse (handles ISO strings, locale strings)
    const parsed = new Date(dateInput);
    if (isValid(parsed)) return parsed;
    // Try MM/DD/YYYY
    const parts = dateInput.split('/');
    if (parts.length === 3) {
      const d = new Date(+parts[2], +parts[0] - 1, +parts[1]);
      if (isValid(d)) return d;
    }
  }
  return defaultDate;
}
